import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/app" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/dashboard/files" />
      },
      {
        exact: true,
        path: '/app/accountDashboard',
        component: () => <Redirect to="/app/accountDashboard/accounts" />
      },
      {
        exact: true,
        path: '/app/accountDashboard/accounts',
        component: lazy(() =>
          import('src/views/accounts/AccountView/CustomerListView')
        )
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/dashboard/files',
        component: lazy(() =>
          import('src/views/reports/DashboardView/CustomerListView')
        )
      },
      {
        exact: true,
        path: '/app/dashboard/files/:id/:fileId',
        component: lazy(() =>
          import('src/views/reports/DashboardView/EditerView')
        )
      },
      {
        exact: true,
        path: '/app/accountDashboard/accounts/:id/:accountId',
        component: lazy(() =>
          import('src/views/accounts/AccountView/AccountInfoView')
        )
      },
      {
        exact: true,
        path: '/app/reports',
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: '/app/generateReport',
        component: lazy(() => import('src/views/reportGeneration/index'))
      },
      {
        exact: true,
        path: '/app/registration',
        component: lazy(() => import('src/views/registration/index'))
      },
      {
        exact: true,
        path: '/app/raisedIssues',
        component: lazy(() => import('src/views/raisedIssues/list/index'))
      },
      {
        exact: true,
        path: '/app/raisedIssue/:issueId',
        component: lazy(() => import('src/views/raisedIssues/details/index'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
